<template>
  <div id="detail-report" class="wrrapper">
    <page-heading title="Visits Report" back>
      <template #content>
        <div class="flex align-center no-print">
          <Select
            placeholder="Filter by"
            :loading="loading"
            :options="listDoctors"
            :input="handleFilters"
          />
          <DateRangePicker @update="updateDate" />
          <ExportButtons @pdf="handleExportPdf" @excel="handleExportExcel" />
        </div>
      </template>
    </page-heading>
    <div class="content" id="doctors-report">
      <data-table
        :loading="loading"
        :cols="columns"
        :rows="details"
        height="calc(100vh - 15rem)"
        total
      >
      </data-table>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import DateRangePicker from "@/components/DateRangePIcker";
import Select from "@/components/Select";
import ExportButtons from "@/components/ExportButtons.vue";
import { exportReportPdf, exportReportExcel } from "@/utils/reportExport";
import { formatedDate } from "@/utils/helpers";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    DateRangePicker,
    DataTable,
    Select,
    ExportButtons
  },
  data() {
    return {
      columns: [
        { column: "serial", label: "#", width: "60" },
        { column: "name", label: "Service" },
        { column: "visits", label: "Visits", sum: true }
      ],
      filters: {
        end_date: formatedDate(),
        start_date: formatedDate()
      }
    };
  },
  methods: {
    ...mapActions("reports", ["detailReport"]),
    ...mapActions("doctors", ["doctorList"]),
    updateDate(val) {
      (this.filters.end_date = formatedDate(val.endDate)),
        (this.filters.start_date = formatedDate(val.startDate));
      this.detailReport(this.filters);
    },
    exportInput() {
      return {
        title: `${this?.employeeDetails?.full_name} Visit's Report`,
        dateRange: {
          start: this.filters.start_date,
          end: this.filters.end_date
        },
        printedBy: this.userInfo.full_name,
        cols: this.columns,
        rows: this.details,
        fileName: "doctor-visits-report"
      };
    },
    handleExportPdf() {
      exportReportPdf(this.exportInput());
    },
    handleExportExcel() {
      exportReportExcel(this.exportInput());
    },
    handleFilters(val) {
      const id = val && val.id !== null ? val.id : "";
      this.filters.lookup_id = id;
      this.detailReport(this.filters);
    }
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      isOther: "auth/isOther",
      userInfo: "auth/userInfo",
      details: "reports/details",
      listDoctors: "doctors/listDoctors",
      employeeDetails: "reports/employeeDetails"
    })
  },

  mounted() {
    this.doctorList("servicehead");
    this.filters.doctor_id = this.$route.params.id;
    this.detailReport(this.filters);
  }
};
</script>

<style>
@import "../../../assets/css/print.css";
</style>
